import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface PostProductRequest {
    product_category_idx: number;
    product_name: string;
    product_code_idx: number;
    product_amount: number;
    product_content: string;
    product_memo: string;
    product_image?: File[];
    notice_image?: File[];
}

export const usePostGoods = (
    successCallback?: (productIdx: number) => void,
): UseMutationResult<null, Error, PostProductRequest, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, PostProductRequest>({
        mutationFn: async (productData: PostProductRequest) => {
            const formData = new FormData();
            formData.append("product_category_idx", productData.product_category_idx.toString());
            productData.product_code_idx !== 0 && formData.append("product_code_idx", productData.product_code_idx.toString());
            formData.append("product_name", productData.product_name);
            formData.append("product_amount", productData.product_amount.toString());
            formData.append("product_content", productData.product_content);
            formData.append("product_memo", productData.product_memo);

            if (productData.product_image) {
                productData.product_image.forEach((file, index) => {
                    formData.append(`product_image`, file);
                });
            }

            if (productData.notice_image) {
                productData.notice_image.forEach((file, index) => {
                    formData.append(`notice_image`, file);
                });
            }
            const response = await axios.post(`${enum_api_uri.post_product}`, formData, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            return response.data.data.product_idx;
        },
        onSuccess: productIdx => {
            queryClient.invalidateQueries({ queryKey: ["getGoodsList"] });
            successCallback?.(productIdx || 0);
        },
    });
};
